// @ts-nocheck
import React, { useState } from 'react';
import ActionBar from '../layout/ActionBar';
import RequestKeys from './slideout/RequestKeys';
import { userIs } from '../auth/authUtils';
import userTypes from '../../constants/userTypes';
import SlidingPane from 'react-sliding-pane';
import { Trans, useTranslation } from 'react-i18next';
import RequestsTable from './components/RequestsTable';
import Button from '../common/Button';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

export interface RequestsProps {
  setCompleteRequestSlideoutOpen: (open: boolean) => void;
}

function Requests({ setCompleteRequestSlideoutOpen }: RequestsProps) {
  usePageTitle(['All requests']);
  const { t } = useTranslation();
  const currentUser = useAppSelector((state) => state.auth);
  const basket = useAppSelector((state) => state.basket);

  const [reload, setReload] = useState<Date | undefined>();
  const [requestKeysSlideoutOpen, setRequestKeysSlideoutOpen] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([
    { label: t('Requests'), link: '/requests/all' },
  ]);

  return (
    <>
      {basket && basket.basketCount > 0 && (
        <div
          tabIndex={0}
          className="alert alert-basket twinkle flex-shrink-0"
          onClick={() => setCompleteRequestSlideoutOpen(true)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setCompleteRequestSlideoutOpen(true);
            }
          }}
        >
          {basket.basketCount > 1 ? (
            <Trans
              i18nKey="basketCount"
              components={{ bold: <b /> }}
              values={{ basketCount: basket.basketCount }}
            >
              You have <bold>{basket.basketCount}</bold> requests to complete in
              your basket.
            </Trans>
          ) : (
            <Trans i18nKey="oneRequestToComplete" components={{ bold: <b /> }}>
              You have <bold>1</bold> request to complete in your basket.
            </Trans>
          )}
        </div>
      )}
      {basket && basket.submittingCount > 0 && (
        <div className="alert alert-basket twinkle flex-shrink-0">
          {basket.submittingCount > 1 ? (
            <Trans
              i18nKey="submittingCount"
              components={{ bold: <b /> }}
              values={{ submittingCount: basket.submittingCount }}
            >
              You have <bold>{basket.submittingCount}</bold> requests being
              processed.
            </Trans>
          ) : (
            <Trans
              i18nKey="oneRequestBeingProcessed"
              components={{ bold: <b /> }}
            >
              You have <bold>1</bold> request being processed.
            </Trans>
          )}
        </div>
      )}
      <ActionBar breadcrumb={breadcrumb}>
        {userIs(currentUser, userTypes.REQUESTER) && (
          <Button
            className="btn btn-primary ms-2"
            onClick={() => setRequestKeysSlideoutOpen(true)}
            text={t('Request keys')}
          />
        )}
      </ActionBar>

      <RequestsTable
        groupedStorageKey="requestsGrouped-all"
        setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
        setBreadcrumb={setBreadcrumb}
        reload={reload}
        setReload={setReload}
      />

      <SlidingPane
        isOpen={requestKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setRequestKeysSlideoutOpen(false)}
      >
        <RequestKeys
          done={() => {
            setRequestKeysSlideoutOpen(false);
            setCompleteRequestSlideoutOpen(true);
          }}
          cancel={() => setRequestKeysSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default Requests;
